export enum CameraImageActionsTypes {
  "LIST_CAMERA_IMAGE" = "LIST_CAMERA_IMAGE",
  "GET_CAMERA_IMAGE" = "GET_CAMERA_IMAGE",
  "DOWNLOAD_CAMERA_IMAGE_ZIP" = "DOWNLOAD_CAMERA_IMAGE_ZIP"
}

export enum CameraImageMutationsTypes {
  "SET_CAMERA_IMAGE" = "SET_CAMERA_IMAGE"
}

export enum CameraImageGettersTypes {
  "CAMERA_IMAGE_BY_ID" = "CAMERA_IMAGE_BY_ID",
  "CAMERA_IMAGE_ALL_ID" = "CAMERA_IMAGE_ALL_ID"
}
